
export const ikeaUrl = (url) => {
  if (url.indexOf('wprw') >= 0) {
    return url;
  }

  return `https://ikea.marat.qd.je${url}`;
};

export const isRunningInProd = window.location.hostname.match(/ikea\.com/);
export const isRunningOnCTE = window.location.hostname.match(/ikeadt\.com/);
export const isRunningOnLocalhost = window.location.hostname.match(/localhost\.com/);

export const formatItemNo = (itemNo) => {
  return itemNo.replace(/(\d{3})(\d{3})(\d{2})/, '$1.$2.$3');
};

export const getPageHeight = () => {
  const {
      body,
      documentElement,
    } = document;

  return Math.max(
      body.scrollHeight,
      body.offsetHeight,
      documentElement.clientHeight,
      documentElement.scrollHeight,
      documentElement.offsetHeight
    );
};

export const getViewportHeight = () => {
  const {
      body,
      documentElement,
    } = document;

  return window.innerHeight || documentElement.clientHeight || body.clientHeight;
};

export const getPageWidth = () => {
  const {
      body,
      documentElement,
    } = document;

  return Math.max(
      body.scrollWidth,
      body.offsetWidth,
      documentElement.clientWidth,
      documentElement.scrollWidth,
      documentElement.offsetWidth
    );
};

export const getOffsetFromTop = () => {
  return window.pageYOffset || document.body.scrollTop || 0;
};

export const isMobile = {
  Windows() {
    return /IEMobile/i.test(navigator.userAgent);
  },
  Android() {
    return /Android/i.test(navigator.userAgent);
  },
  BlackBerry() {
    return /BlackBerry/i.test(navigator.userAgent);
  },
  iOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  },
  any() {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows());
  },
};

export const isRTL = () => {  
  const body = document.body;
  return body.dir =='rtl';
};

export function imgLoaded(imgElement) {
  return imgElement.complete && (imgElement.naturalWidth !== 0 || imgElement.src.indexOf('svg') >= 0);
}
